/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ItemPriceUpdateService = {
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async getDataByCode(requestScreenData) {
    return await ApiService.oDataGet(requestScreenData);
  },

  async saveItemPrice(payload) {
    var url = 'api/Save_ItemPrice';
    return await ApiService.post(url, payload);
  },

};

export { ItemPriceUpdateService };
